<script setup lang="ts">
import FavoritarObra from './shared/favorito/FavoritarObra.vue';
import { useSidebarStore } from '@/stores/sidebar';
import { useObraStore } from '@/stores/obras';
useSidebarStore();
useObraStore();
</script>
<template>
    <div v-if="SidebarStore.open || $route.name == 'mobile-lista'">
        <template v-for="(obra, index) in listaObras" :key="index">
            <div class="row item" @click="selecionar(obra)"
                :class="{ active: ObraStore.obraSelecionada?.codLote == obra.codLote }">
                <div class="col-9 title">
                    <h5>{{ obra.descLote }}</h5>
                </div>
                <div class="col-3 departamento">
                    <h5 style="text-align: right;">{{ obra.siglaDepartamento }}</h5>
                </div>
                <div class="col-12 endereco">
                    <h6>{{ obra.endereco }}</h6>
                </div>
                <div class="col-10 small">
                    <div class="row">
                        <div class="col-6 info-no-color">PROCESSO</div>
                        <div class="col-6 max-linhas-1 info">
                            <h5>{{ obra.numProcesso }}</h5>
                        </div>
                        <div class="col-6 info-no-color">CONTRATO</div>
                        <div class="col-6 max-linhas-1 info">
                            <h5> {{ obra.numContrato }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-2 small">
                    <favoritar-obra :obra="obra" />
                </div>
                <div class="col-12 small">
                    <div class="row">
                        <div class="col-5 info-no-color">SITUAÇÃO</div>
                        <div class="col-7 situacao" style="font-weight: bolder"
                            v-bind:style="{ color: obterHexCodeColoracao(obra) }">
                            {{ obra.situacao }}
                        </div>
                    </div>
                </div>
                <div class="col-12 small">
                    <div class="row">
                        <div class="col-5 info-no-color">VALOR ATUAL</div>
                        <div class="col-7 max-linhas-1 info">
                            <h5>{{ formatMoeda(obra.valorAtual) }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-5 info-no-color">% EXECUTADA</div>
                        <div class="col-7 info">
                            <h5>{{ obra.porcentagemExecutada }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-11 small my-2">
                    <div class="meter-container">
                        <div class="meter" :class="{ 'meter-completed': obra.porcentagemExecutada == '100,00%' }"
                            v-bind:style="{ width: calcularPorcentagem(obra), background: obterHexCodeColoracao(obra) }">
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import Filtros from '@/services/model/filtros';
import FiltroPadrao from '@/services/model/filtroPadrao';
import Obra from '@/services/model/obra';
import Item from '@/services/model/item';

class ListagemObrasData {
    public listaObras: Array<Obra> = new Array<Obra>();
    public listaObrasPaginadas: Array<Obra> = new Array<Obra>();
    public listaObrasFavoritas: Array<Obra> = new Array<Obra>();
    public filtroPadrao: FiltroPadrao = new FiltroPadrao();
    public filtros: Filtros = new Filtros();
    public ufs: Array<Item> = new Array<Item>();
    public municipios: Array<Item> = new Array<Item>();
    public situacaoCorDicionario: Map<string, string> = new Map<string, string>();
}

export default defineComponent({
    name: 'ListagemObras',
    data() {
        return new ListagemObrasData();
    },
    computed: {
        ...mapStores(useObraStore),
        ...mapStores(useSidebarStore)
    },
    watch: {
        'ObraStore.obrasFiltradasOrdenadas': function () {
            if (this.ObraStore.listarObrasSelecionadas)
                this.listaObras = this.ObraStore.obrasSelecionadasFiltradasOrdenadas;
            else
                this.listaObras = this.ObraStore.obrasFiltradasOrdenadas;
        },
        'ObraStore.listarObrasSelecionadas': function () {
            if (this.ObraStore.listarObrasSelecionadas)
                this.listaObras = this.ObraStore.obrasSelecionadasFiltradasOrdenadas;
            else
                this.listaObras = this.ObraStore.obrasFiltradasOrdenadas;
        },
        'ObraStore.obrasSelecionadasFiltradasOrdenadas': function () {
            if (this.ObraStore.listarObrasSelecionadas)
                this.listaObras = this.ObraStore.obrasSelecionadasFiltradasOrdenadas;
            else
                this.listaObras = this.ObraStore.obrasFiltradasOrdenadas;
        }
    },
    emits: ['selecionar'],
    async mounted() {

        this.carregar();

        this.construirDicionarioCor();
    },
    methods: {
        carregar() {

            this.listaObras = this.ObraStore.listarObrasSelecionadas
                ? this.ObraStore.obrasSelecionadasFiltradasOrdenadas
                : this.ObraStore.obrasFiltradasOrdenadas;
        },
        selecionar(obra: Obra) {
            this.$emit("selecionar", obra);
        },
        calcularPorcentagem(obra: Obra) {
            return obra.porcentagemExecutada.replace(/,/g, '.');
        },
        construirDicionarioCor() {
            var dictionary = new Map<string, string>();
            //verde
            dictionary.set('Contratado_Ativo', '#1ab394');
            dictionary.set('Contratado_EmExecucao', '#1ab394');
            dictionary.set('Concluido_Executado', '#1ab394');
            dictionary.set('Concluido_Executado_Provisorio', '#1ab394');
            dictionary.set('Concluido_Executado_Definitivo', '#1ab394');
            dictionary.set('Concluido_Realizado', '#1ab394');
            //amarelo EF980F
            dictionary.set('Iniciado', '#f58634');
            dictionary.set('Orcando', '#f58634');
            dictionary.set('Orcado', '#f58634');
            dictionary.set('Licitando', '#f58634');
            dictionary.set('Licitado', '#f58634');
            //vermelho
            dictionary.set('Contratado_Paralisado', '#ed5565');
            dictionary.set('Contratado_EmAberto', '#ed5565');
            dictionary.set('Concluido_Expirado', '#ed5565');
            dictionary.set('Contratado_Desistido', '#ed5565');
            dictionary.set('Concluido_Rescindido', '#ed5565');
            dictionary.set('Contratado_Rescindido', '#ed5565');
            dictionary.set('Concluido_Desistido', '#ed5565');
            dictionary.set('Licitado_Desistido', '#ed5565');
            dictionary.set('Licitado_Rescindido', '#ed5565');
            //cinza
            dictionary.set('Suspenso', '#696969');
            this.situacaoCorDicionario = dictionary;
        },
        obterHexCodeColoracao(obra: Obra) {
            return this.situacaoCorDicionario.get(obra.situacaoHexKey) ?? '';
        },
        formatMoeda(moeda: number) {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(moeda);
        }
    }
});
</script>
<style scoped>
.active {
    background-color: #164e79;
    color: #fff;
}

.title h5 {
    color: #f58634;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.004in;
    margin-bottom: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-transform: uppercase;
}

.active .title h5 {
    color: #fff;
}

.info h6 {
    font-size: 12px;
    text-transform: uppercase;
    margin: 0;
}

.info h5 {
    margin: 0;
    font-size: 12px;
    font-weight: 900;
    color: #164e79;
    text-transform: uppercase;

}

.active .info h5 {
    color: #fff;
}

.info-no-color {
    font-size: 9.5pt;
    color: #858c8f;
}

.active .info-no-color {
    font-size: 9.5pt;
    color: #fff;
}

.departamento {
    background-color: #164e79;
    color: #fff;
    border: solid 1px #164e79;
    border-top-left-radius: 0.7em;
    border-bottom-left-radius: 0.7em;
    padding-right: 50px;
}

.active .departamento {
    background-color: #fff;
    color: #164e79;
    border: solid 1px #164e79;
}

.departamento h5 {
    font-size: 1em;
    color: #fff;
    margin: 0;
}

.active .departamento h5 {
    color: #164e79;
}

.endereco h6 {
    text-transform: uppercase;
    font-size: 0.7em;
}

.item {
    border-bottom: 1px solid #bbcbd8;
    margin-bottom: 10px;
}

.item:hover {
    cursor: pointer;
}

.situacao {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.meter-container {
    height: 10px;
    position: relative;
    background: rgb(203, 203, 203);
    background: linear-gradient(180deg, rgba(203, 203, 203, 1) 0%, rgba(255, 255, 255, 1) 100%);
    border-radius: 10px;
    padding: 0px;
}

.meter {
    height: 10px;
    position: static;
    background: #00ff21;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding: 5px;
    overflow: hidden;
}

.meter-completed {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
</style>